// A short address for headers and bars: no country or zip, and a US state as
// its two-letter code — "Salem, Massachusetts, United States" → "Salem, MA",
// "1420 Lafayette St, Salem, MA 01970, USA" → "1420 Lafayette St, Salem, MA".

const STATES = {
  alabama: "AL", alaska: "AK", arizona: "AZ", arkansas: "AR", california: "CA", colorado: "CO",
  connecticut: "CT", delaware: "DE", "district of columbia": "DC", florida: "FL", georgia: "GA",
  hawaii: "HI", idaho: "ID", illinois: "IL", indiana: "IN", iowa: "IA", kansas: "KS", kentucky: "KY",
  louisiana: "LA", maine: "ME", maryland: "MD", massachusetts: "MA", michigan: "MI", minnesota: "MN",
  mississippi: "MS", missouri: "MO", montana: "MT", nebraska: "NE", nevada: "NV", "new hampshire": "NH",
  "new jersey": "NJ", "new mexico": "NM", "new york": "NY", "north carolina": "NC", "north dakota": "ND",
  ohio: "OH", oklahoma: "OK", oregon: "OR", pennsylvania: "PA", "rhode island": "RI",
  "south carolina": "SC", "south dakota": "SD", tennessee: "TN", texas: "TX", utah: "UT", vermont: "VT",
  virginia: "VA", washington: "WA", "west virginia": "WV", wisconsin: "WI", wyoming: "WY",
  "puerto rico": "PR",
};
const CODES = new Set(Object.values(STATES));
const US = /^(usa|us|united states( of america)?)$/i;

export function shortAddress(text) {
  const parts = String(text || "")
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
  if (parts.length > 1 && US.test(parts[parts.length - 1])) parts.pop();
  if (parts.length > 1) {
    // The last part is the state, maybe with a zip: "Massachusetts 01970", "MA".
    const m = parts[parts.length - 1].match(/^([A-Za-z .]+?)\s*(\d{5}(-\d{4})?)?$/);
    if (m) {
      const name = m[1].trim();
      const code = STATES[name.toLowerCase()] || (CODES.has(name.toUpperCase()) ? name.toUpperCase() : null);
      if (code) parts[parts.length - 1] = code;
    }
  }
  return parts.join(", ");
}

// Just the place, for the top bar's "Salem, MA · Now" pill: the last two parts
// of the short address ("12 Derby St, Salem, MA" → "Salem, MA").
export function cityLine(text) {
  const parts = shortAddress(text).split(", ").filter(Boolean);
  return parts.length > 2 ? parts.slice(-2).join(", ") : parts.join(", ");
}
